var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAuthenticated)?_vm._t("authenticated"):_vm._t("anonymous")],2)}
var staticRenderFns = []

export { render, staticRenderFns }